// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2dktS","requiredAsterisk":"Info_requiredAsterisk__xdEVs"};